import angular from 'angular';
import {
  userService,
  loaderService,
  ssDialogService,
  assetSharedModelService,
  assetDataService,
  praDataService,
} from 'app/services';
import {
  actionIcon,
  statusMeter,
  helpTooltip
} from 'app/components/global';
import bulkDeleteAssetsDialog from '../dialog.bulkDeleteAssetsDialog';
import bulkChangeAssetTypesDialog from '../dialog.bulkChangeAssetTypesDialog';
import controller from './assets-by-type.controller';
import directive from './assets-by-type.directive';
import asset from '../asset';
import editAssetDialog from '../dialog.editAssetDialog';
import syncAssetTypeDialog from './dialog.syncAssetType';


const assetsByTypeModule = angular.module('app.components.admin.assetAdmin.assetsByType', [
  userService,
  actionIcon,
  loaderService,
  ssDialogService,
  assetSharedModelService,
  assetDataService,
  statusMeter,
  helpTooltip,
  asset,
  editAssetDialog,
  praDataService,
  bulkDeleteAssetsDialog,
  bulkChangeAssetTypesDialog,
  syncAssetTypeDialog
])
  .directive('assetsByType', directive)
  .controller('AssetsByTypeController', controller);

export default assetsByTypeModule.name;

console.log('app.components.admin.assetAdmin.assetsByType created');
